"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDocumentFromResourceButton = exports.assertNeverHit = exports.DOCUMENT_TYPE_WORKBOOK = exports.DOCUMENT_TYPE_FLOW = exports.RESOURCE_TYPE_TABLE = exports.RESOURCE_TYPE_DATABASE = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const FlowBaseIcon_1 = require("@tableau/icons/FlowBaseIcon");
const TableauFileWorkbookBaseIcon_1 = require("@tableau/icons/TableauFileWorkbookBaseIcon");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
const CreateContentItemFromTelemetryEvent_1 = require("./CreateContentItemFromTelemetryEvent");
exports.RESOURCE_TYPE_DATABASE = 'database';
exports.RESOURCE_TYPE_TABLE = 'table';
exports.DOCUMENT_TYPE_FLOW = 'flow';
exports.DOCUMENT_TYPE_WORKBOOK = 'workbook';
/**
 * Will inform the typesystem that the parameter n should never be valid.  This is useful for
 * putting in the default of switch statements, as it will allow the type checker to verify that you
 * exhausted all the type possibilities in case statemeents.  You will then get a compile error, if someone
 * adds something that needs a new case statement, but one isn't there.
 *
 * @param n  the parameter passed to the switch statement.
 */
function assertNeverHit(_n) {
    throw new Error('{0} is a case the type system thought was impossible to get to.  See if your types are right!');
}
exports.assertNeverHit = assertNeverHit;
function createHandleNewFlowForDatabaseAction(databaseId, siteUrls, newWindow, databaseClass, sendCreateDocumentEvent, projectIdForNewDocuments) {
    return () => {
        newWindow.location.href = siteUrls.flowEditorFlowPath({
            flowLuid: 'new',
            graphQLDatabaseId: databaseId,
            projectId: projectIdForNewDocuments,
        });
        if (sendCreateDocumentEvent) {
            const sendEvent = {
                type: 'create_content_from_item',
                content_type: CreateContentItemFromTelemetryEvent_1.ContentType.Flow,
                data_type: CreateContentItemFromTelemetryEvent_1.DataType.Database,
                connection_type: databaseClass,
            };
            sendCreateDocumentEvent(sendEvent);
        }
    };
}
function createHandleNewFlowForTableAction(tableId, siteUrls, newWindow, databaseClass, sendCreateDocumentEvent, projectIdForNewDocuments) {
    return () => {
        newWindow.location.href = siteUrls.flowEditorFlowPath({
            flowLuid: 'new',
            graphQLTableId: tableId,
            projectId: projectIdForNewDocuments,
        });
        if (sendCreateDocumentEvent) {
            const sendEvent = {
                type: 'create_content_from_item',
                content_type: CreateContentItemFromTelemetryEvent_1.ContentType.Flow,
                data_type: CreateContentItemFromTelemetryEvent_1.DataType.Table,
                connection_type: databaseClass,
            };
            sendCreateDocumentEvent(sendEvent);
        }
    };
}
function createHandleNewWorkbookForTableAction(tableId, siteUrls, newWindow, databaseClass, sendCreateDocumentEvent) {
    return () => {
        newWindow.location.href = siteUrls.newWorkbookFromTable(tableId);
        if (sendCreateDocumentEvent) {
            const sendEvent = {
                type: 'create_content_from_item',
                content_type: CreateContentItemFromTelemetryEvent_1.ContentType.Workbook,
                data_type: CreateContentItemFromTelemetryEvent_1.DataType.Table,
                connection_type: databaseClass,
            };
            sendCreateDocumentEvent(sendEvent);
        }
    };
}
function createHandleNewWorkbookForDatabaseAction(databaseId, siteUrls, newWindow, databaseClass, sendCreateDocumentEvent) {
    return () => {
        newWindow.location.href = siteUrls.newWorkbookFromDatabase(databaseId);
        if (sendCreateDocumentEvent) {
            const sendEvent = {
                type: 'create_content_from_item',
                content_type: CreateContentItemFromTelemetryEvent_1.ContentType.Workbook,
                data_type: CreateContentItemFromTelemetryEvent_1.DataType.Database,
                connection_type: databaseClass,
            };
            sendCreateDocumentEvent(sendEvent);
        }
    };
}
function isRowEnabledForTableOrDatabase(connectionType, allowedClasses) {
    return connectionType ? allowedClasses.indexOf(connectionType) > -1 : false;
}
function getCreateHandlerForDatabase(documentType) {
    switch (documentType) {
        case exports.DOCUMENT_TYPE_FLOW:
            return (0, reselect_1.defaultMemoize)(createHandleNewFlowForDatabaseAction);
        case exports.DOCUMENT_TYPE_WORKBOOK:
            return (0, reselect_1.defaultMemoize)(createHandleNewWorkbookForDatabaseAction);
        default:
            assertNeverHit(documentType);
    }
}
function getCreateHandlerForTable(documentType) {
    switch (documentType) {
        case exports.DOCUMENT_TYPE_FLOW:
            return (0, reselect_1.defaultMemoize)(createHandleNewFlowForTableAction);
        case exports.DOCUMENT_TYPE_WORKBOOK:
            return (0, reselect_1.defaultMemoize)(createHandleNewWorkbookForTableAction);
        default:
            assertNeverHit(documentType);
    }
}
function getCreateHandler(resourceType, documentType) {
    switch (resourceType) {
        case exports.RESOURCE_TYPE_DATABASE:
            return getCreateHandlerForDatabase(documentType);
        case exports.RESOURCE_TYPE_TABLE:
            return getCreateHandlerForTable(documentType);
        default:
            assertNeverHit(resourceType);
    }
}
class CreateDocumentFromResourceButton extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.createButtonRef = react_1.default.createRef();
        this.toggleMenu = () => {
            this.setState({
                isMenuOpen: !this.state.isMenuOpen,
            });
        };
        this.hideMenu = () => {
            this.setState({
                isMenuOpen: false,
            });
        };
        this.menuSelect = (value) => {
            this.hideMenu();
            const newWindow = window.open('', '_blank');
            const databaseClass = this.props.databaseClass ? this.props.databaseClass : '';
            const sendCreateEvent = this.props.sendCreateDocumentEvent ? this.props.sendCreateDocumentEvent : undefined;
            if (newWindow) {
                let createHandler;
                if (value === exports.DOCUMENT_TYPE_WORKBOOK) {
                    createHandler = getCreateHandler(this.props.resourceType, exports.DOCUMENT_TYPE_WORKBOOK)(this.props.resourceId, this.props.siteUrls, newWindow, databaseClass, sendCreateEvent);
                }
                else if (value === exports.DOCUMENT_TYPE_FLOW) {
                    createHandler = getCreateHandler(this.props.resourceType, exports.DOCUMENT_TYPE_FLOW)(this.props.resourceId, this.props.siteUrls, newWindow, databaseClass, sendCreateEvent, this.props.projectIdForNewDocuments);
                }
                if (createHandler != null && createHandler !== undefined) {
                    createHandler();
                }
            }
        };
        this.getWorkbookResourceUsageTitle = (resType) => {
            switch (resType) {
                case 'database':
                    return catalog_messages_1.Messages.WorkbookUsingThisDatabaseTitle();
                case 'table':
                    return catalog_messages_1.Messages.WorkbookUsingThisTableTitle();
                default:
                    assertNeverHit(resType);
            }
        };
        this.getFlowResourceUsageTitle = (resType) => {
            switch (resType) {
                case 'database':
                    return catalog_messages_1.Messages.FlowUsingThisDatabaseTitle();
                case 'table':
                    return catalog_messages_1.Messages.FlowUsingThisTableTitle();
                default:
                    assertNeverHit(resType);
            }
        };
        this.generateMenuItems = () => {
            const menuItems = [];
            const isWorkbookCreationDisabled = !this.props.canCreateWorkbook;
            const isFlowCreationDisabled = !this.props.canCreateFlow;
            menuItems.push({
                value: exports.DOCUMENT_TYPE_WORKBOOK,
                displayValue: this.getWorkbookResourceUsageTitle(this.props.resourceType),
                icon: TableauFileWorkbookBaseIcon_1.TableauFileWorkbookBaseIcon,
                disabled: isWorkbookCreationDisabled,
            }, {
                value: exports.DOCUMENT_TYPE_FLOW,
                displayValue: this.getFlowResourceUsageTitle(this.props.resourceType),
                icon: FlowBaseIcon_1.FlowBaseIcon,
                disabled: isFlowCreationDisabled,
            });
            return menuItems;
        };
        this.renderMenu = () => {
            return (react_1.default.createElement(widgets_1.FlyoutListMenuWidget, { allowAutoPosition: true, anchorEl: this.createButtonRef.current, anchorOrigin: {
                    vertical: widgets_1.VerticalOriginOption.bottom,
                    horizontal: widgets_1.HorizontalOriginOption.left,
                }, menuItemInfos: this.generateMenuItems(), onSelect: this.menuSelect, requestCloseAll: this.hideMenu, id: 'create-content-buttons-menu', testId: 'create-content-buttons-menu', toggleEl: this.createButtonRef.current, menuStyle: { minWidth: '150px', whiteSpace: 'nowrap' } }));
        };
        this.state = {
            isSupportedDatabaseClass: false,
            isMenuOpen: false,
        };
    }
    componentDidMount() {
        this
            .props
            .apiRequests
            .getAllowedClasses({ federatableOnly: 'false' })
            .then((r) => {
            const isSupported = isRowEnabledForTableOrDatabase(this.props.databaseClass, r.allowedClasses);
            this.setState({
                isSupportedDatabaseClass: isSupported,
                isMenuOpen: false,
            });
        })
            .catch((_) => {
            this.setState({
                isSupportedDatabaseClass: false,
                isMenuOpen: false,
            });
        }); // Leave the state as the default
    }
    render() {
        const disabled = !this.props.canCreateFlow && !this.props.canCreateWorkbook;
        return (react_1.default.createElement("div", { title: disabled ? catalog_messages_1.Messages.ConnectToUnsupportedRowWarningTextDefault() : undefined },
            react_1.default.createElement(widgets_1.MenuButtonWidget, { "aria-haspopup": 'menu', "aria-controls": 'create-content-buttons-panel', onClick: this.toggleMenu, ref: this.createButtonRef, testId: 'create-content-button', disabled: disabled },
                catalog_messages_1.Messages.New(),
                this.state.isMenuOpen ? this.renderMenu() : null)));
    }
}
exports.CreateDocumentFromResourceButton = CreateDocumentFromResourceButton;
//# sourceMappingURL=CreateWorkbookFromCatalogButtons.js.map